import { createSlice } from "@reduxjs/toolkit"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

import { ERRORS_SLICE_NAME } from "./errors.constants"

const initialState = {
  data: null
}

// Some upstream error responses (proxy timeouts, gateway errors) come back as a
// raw HTML page instead of JSON/text.
const HTML_BODY_PATTERN = /^\s*<(!doctype|html)/i

const sanitizeErrorPayload = (payload) =>
  typeof payload === "string" && HTML_BODY_PATTERN.test(payload) ? "Server response error" : payload

const slice = createSlice({
  name: ERRORS_SLICE_NAME,
  initialState,
  reducers: {
    errorSave(state, action) {
      state.data = sanitizeErrorPayload(action.payload)
    },
    errorReset() {
      return initialState
    }
  }
})

export const ErrorsActions = slice.actions

export const ErrorsSelectors = {
  getState: (state) => state.errors
}

const PERSISTED_REDUCER_VERSION = 2

export const persistedReducer = persistReducer(
  {
    key: "errors",
    storage,
    version: PERSISTED_REDUCER_VERSION,
    migrate: async (state) => {
      if (state?._persist?.version < PERSISTED_REDUCER_VERSION) {
        return {
          ...state,
          ...initialState
        }
      }
      return state
    }
  },
  slice.reducer
)

export const reducer = persistedReducer
